export default (...classNames: string[]) => classNames.filter(Boolean).join(' ');

